import React, { useState, useEffect } from 'react';
import Header from '../../dashboard/header';
import { Link } from 'react-router-dom';
import { Table, Modal, Button } from 'react-bootstrap';
import { FaPlus, FaCheck, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaUniversalAccess, FaUser, FaTools, FaArrowRight, FaArrowLeft } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../../dashboard/sidebar';
import Ajouter_acces from '../../administration/groupe/ajouter_acces';
import useAuth from '../../dashboard/useAuth';
import { BsPeople } from 'react-icons/bs';
import axios from 'axios';

const Liste_eco = ({ titre }) => {
    useAuth();
    const existingAcces = { acces: [] };

    const [selectedEco, setSelectedEco] = useState(null);
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [expandedEcoIds, setExpandedEcoIds] = useState([]);
    const [ecoDescriptionOverflows, setEcoDescriptionOverflows] = useState({});
    const [showImportModal, setShowImportModal] = useState(false);
    const [file, setFile] = useState(null);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Eco"; // Changement ici
        }
    }, [user_id]);

    const [showClearModal, setShowClearModal] = useState(false); // Gérer l'affichage du modal



    const clearTable = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/vider-eco/`, {
                method: 'POST',
            });
            const data = await response.json();

            if (response.ok) {
                showAlert("Table Eco vidée avec succès !");
                fetchEcos();
            } else {
                console.error('Erreur lors de la suppression des ecos.', data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setShowClearModal(false); // Ferme le modal
        }
    };


    const [ecos, setEcos] = useState([]);
    const fetchEcos = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-eco/');
            if (response.ok) {
                const data = await response.json();
                setEcos(data);
            } else {
                console.error('Erreur lors de la récupération des ecos');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };
    useEffect(() => {

        fetchEcos();
    }, []);

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        // setTimeout(() => {
        //     setAlert({ message: '', type: '' });
        // }, 7000);
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    }

    const handleRowClick = (eco) => {
        setSelectedEco(eco);
    };

    // Gérer l'import du fichier
    const handleFileUpload = async () => {
        if (!file) return; // Si aucun fichier n'est sélectionné, ne rien faire

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/importer-eco/`,
                {
                    method: 'POST',
                    body: formData,
                }
            );

            const data = await response.json();

            if (response.ok) {
                let successMessage = `Import réussi : ${data.imported_count} ajouté(s), ${data.skipped_count} ignoré(s)`;

                if (data.message) {
                    successMessage += `\n📝 Message: ${data.message}`;
                }

                showAlert(successMessage, 'success');
                fetchEcos();
            } else {
                let errorMessage = 'Erreur lors de l\'import : ';

                if (data.message) {
                    errorMessage += `\n⚠️ ${data.message}`;
                }
                if (data.errors_html && data.errors_html.length > 0) {
                    errorMessage += `\n❌ Erreurs détectées :\n- ${data.errors.join('\n- ')}`;
                }
                if (data.details) {
                    errorMessage += `\nℹ️ Détails : ${data.details}`;
                }

                showAlert(errorMessage, 'danger');
            }
        } catch (error) {
            console.error('Erreur d\'importation :', error);
            showAlert('🚨 Erreur réseau : Impossible d\'importer le fichier.', 'danger');
        } finally {
            setShowImportModal(false); // Fermer le modal après l'import
            setFile(null); // Réinitialiser le fichier sélectionné
        }
    };


    // Fonction pour gérer l'événement de sélection de fichier
    const handleFileChange = (event) => {
        const selectedFile = event.target.files ? event.target.files[0] : null; // Vérifie si files existe
        setFile(selectedFile); // Mettre à jour l'état du fichier
    };

    const handleDeleteEco = async () => {
        if (selectedEco) {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-eco/${selectedEco.ordre}/`, {
                    method: 'DELETE',
                });

                if (response.ok) {
                    setEcos(ecos.filter((eco) => eco.id !== selectedEco.id));
                    setSelectedEco(null);
                    showAlert("Eco supprimé avec succès !");
                } else {
                    console.error('Erreur lors de la suppression de l\'eco');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setShowDeleteModal(false);
            }
        }
    };

    const handleCloseModal = () => setShowModal(false);

    const filteredEcos = ecos.filter(eco =>
        eco.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (eco.ordre && typeof eco.ordre === 'string' ? eco.ordre.toLowerCase() : '').includes(searchTerm.toLowerCase()) ||
        eco.description.toString().includes(searchTerm.toLowerCase()) ||
        eco.ajoute_par.toString().includes(searchTerm.toLowerCase())
    );

    const sortedEcos = [...filteredEcos].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const handleShowDeleteModal = () => {
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    // Pagination logic
    const indexOfLastEco = currentPage * itemsPerPage;
    const indexOfFirstEco = indexOfLastEco - itemsPerPage;
    const currentEcos = sortedEcos.slice(indexOfFirstEco, indexOfLastEco);
    const totalPages = Math.ceil(sortedEcos.length / itemsPerPage);
    const totalItems = ecos.length;

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleToggleDescription = (id) => {
        console.log("Toggling description for ID:", id);
        setExpandedDescriptions((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const checkEcoDescriptionOverflow = (ecos) => {
        ecos.forEach((eco) => {
            const element = document.getElementById(`eco-description-${eco.id}`);
            if (element) {
                setEcoDescriptionOverflows((prev) => ({
                    ...prev,
                    [eco.id]: element.scrollHeight > element.clientHeight,
                }));
            }
        });
    };

    useEffect(() => {
        checkEcoDescriptionOverflow(ecos);
    }, [ecos]);

    const handleModifier = (eco) => {
        if (eco) {
            navigate(`/Modifier-eco`, {
                state: { eco_id: eco.ordre },
            });
        }
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("QCM")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="mr-2"><i className="fa fa-th fa-1x mr-2"></i>Écos</h2>
                            <small>Administration des écos.</small>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/Liste-eco`}> Écos</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    {/* <Header titre="Écos" sous_titre="Dashboard" sous_titre1={<Link to={`/admin`} className='text-dark'>Administration</Link>} entete="Écos"  user_id={user_id}/> */}
                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Écos</h5>
                                <div>
                                    <button
                                        onClick={() => setShowClearModal(true)} // Ouvre le modal
                                        className="btn btn-danger ms-2 mr-2"
                                    >
                                        Vider la table
                                    </button>

                                    <button
                                        onClick={handleShowDeleteModal}
                                        className={`btn ms-2 mr-2 ${selectedEco ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedEco}>
                                        <FaTrash /> Supprimer
                                    </button>
                                    <button
                                        onClick={() => handleModifier(selectedEco)}
                                        className={`btn ms-2 mr-2 ${selectedEco ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedEco} // Désactiver le bouton si aucun éco n'est sélectionné
                                    >
                                        <FaEdit /> Modifier
                                    </button>
                                    <Link to={`/Ajouter-eco`} className="btn btn-success ms-2 mr-2">
                                        <FaPlus /> Ajouter
                                    </Link>
                                    <button
                                        className="btn btn-success ms-2"
                                        onClick={() => setShowImportModal(true)} // Ouvrir le modal
                                    >
                                        Importer CSV
                                    </button>
                                </div>
                            </div>


                            {alert.message && (
                                <div className={`alert alert-${alert.type} row justify-content-between position-relative`}>
                                    <div
                                        // Utilisation de dangerouslySetInnerHTML pour afficher le message HTML
                                        dangerouslySetInnerHTML={{ __html: alert.message }}
                                    />

                                    <span
                                        onClick={fermerNotif}
                                        style={{
                                            position: 'absolute',
                                            top: '0px',   // Ajustez l'espacement comme vous le souhaitez
                                            right: '10px', // Ajustez l'espacement comme vous le souhaitez
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <i className='fa fa-close'></i>
                                    </span>
                                </div>
                            )}

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">

                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control"
                                                    style={{ maxWidth: '150px', width: '100%' }} // Largeur fixe ou maximale selon besoin
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell'
                                                                style={{ width: '15%' }}
                                                                onClick={() => handleSort('titre')}
                                                            >
                                                                Titre
                                                                {sortConfig.key === 'titre'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell'
                                                                onClick={() => handleSort('description')}
                                                            >
                                                                Description
                                                                {sortConfig.key === 'description'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th onClick={() => handleSort('ajoute_par')}>Ajouté par {sortConfig.key === 'ajoute_par'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th onClick={() => handleSort('ordre')}>Ordre {sortConfig.key === 'ordre'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentEcos.map((eco) => {
                                                            const isExpanded = expandedDescriptions[eco.id];
                                                            return (
                                                                <tr
                                                                    key={eco.id}
                                                                    onClick={() => handleRowClick(eco)}
                                                                    className={`bg-white ${selectedEco && selectedEco.id === eco.id ? 'bg-success text-white' : ''}`}>
                                                                    <td>
                                                                        {eco.titre}
                                                                        <div className='lesInfos'>
                                                                            <small>Description : {eco.description}</small>
                                                                            {/* <small>Ajouté par : {eco.ajoute_par}</small> */}
                                                                        </div>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        {eco.description ? eco.description : 'non défini'}
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        {eco.ajoute_par}
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        {eco.ordre}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* Pagination Controls */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstEco + 1} à ${Math.min(indexOfLastEco, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5; // Nombre total de pages à afficher
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        // Ajuster le startPage si la fin dépasse le total des pages
                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        // Ajout des boutons de pages
                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    {/* Bouton pour aller à la dernière page */}
                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/* Modal de confirmation de suppression */}
                            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                                <Modal.Header>
                                    <Modal.Title>Confirmer la Suppression</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Êtes-vous sûr de vouloir supprimer l'éco <strong>{selectedEco?.titre}</strong> ?
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                                        Annuler
                                    </Button>
                                    <Button variant="success" onClick={handleDeleteEco}> {/* Remplacement ici */}
                                        Supprimer
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={showImportModal} onHide={() => setShowImportModal(false)}>
                                <Modal.Header>
                                    <Modal.Title>Importer un fichier CSV</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div>
                                        <input
                                            type="file"
                                            accept=".csv"
                                            onChange={handleFileChange} // Utiliser la fonction modifiée ici
                                        />
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowImportModal(false)}>
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={handleFileUpload}
                                        disabled={!file} // Désactiver le bouton si aucun fichier n'est sélectionné
                                    >
                                        Importer
                                    </Button>
                                </Modal.Footer>
                            </Modal>


                            <Modal show={showClearModal} onHide={() => setShowClearModal(false)}>
                                <Modal.Header>
                                    <Modal.Title>Confirmation</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Êtes-vous sûr de vouloir vider la table ? Cette action est irréversible.
                                </Modal.Body>
                                <Modal.Footer>
                                    <button className="btn btn-secondary" onClick={() => setShowClearModal(false)}>
                                        Annuler
                                    </button>
                                    <button className="btn btn-success" onClick={clearTable}>
                                        Vider
                                    </button>
                                </Modal.Footer>
                            </Modal>

                        </div>
                    </div>

                    {/* Styles CSS pour les cellules fixes */}
                    <style jsx>{`
                        width: 300px; /* Ajustez cette valeur selon vos besoins */
                        overflow: hidden; /* Évite le débordement de contenu */
                        text-overflow: ellipsis; /* Ajoute des "..." pour le contenu tronqué si nécessaire */
                        word-wrap: break-word; /* Permet au texte de s'enrouler et de casser les mots longs */
                        overflow-wrap: break-word; /* Ajoute cette propriété pour la compatibilité */
                        white-space: normal; /* Permet le retour à la ligne */
                    `}</style>
                </div>
            </div>
        </div>
    );
};

export default Liste_eco; 
